module.exports = __webpack_public_path__ + "static/media/169206_382135941875791_2007966827_o.abd78d8c.jpg";